<template>
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <div class="margin-top-30"></div>
      <div class="content1">
        <ul >
          <li v-for="(tab,index) in tabs"  :class="{active:num==index}" @click="table(index)" class="btn">{{tab}}</li>
        </ul>
        <div class="clearfix margin-bottom-20"></div>
        <div class="tabContent">
          <!-- <div v-for="(tabCon,index) in tabsCon" v-show="index==num">{{tabCon}}</div>-->
          <news-list :arrs="arrs"></news-list>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import NewsList from './components/NewsList'
import PersonalCenter from '@/common/components/PersonalCenter'
import axios from 'axios'
export default {
  name: 'Examination',
  components: {
    HomeHeader,
    Foot,
    NewsList,
    PersonalCenter
  },
  data: function () {
    return {
      arrs: [],
      tabs:['待考科目','补考科目','已通过考科目'],
      tabsCon:['内容1','内容2','内容3'],
      num:0
    }
  },
  methods: {
    getDetailInfo () {
      axios.get('http://localhost:8080/static/mock/index.json').then(this.handleGetDataSucc)
    },
    handleGetDataSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.arrs = data.course
      }
    },
    table(index) {
      this.num = index;
    }
  },
  mounted () {
    this.getDetailInfo()
  }
}
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .page-width{
    width:$pageWidth;
    margin:0 auto;
    .content-right{
      margin-top:30px;
      .localtion{
        line-height 30px;
        border-bottom:1px solid $borderColor;
        margin-bottom:20px;
      }
    }
  }
  .content1{
    background:#fff;
    padding:28px;
  }
  .content-left{
    background:#f7f6f6;
  }
  li.btn{
    float: left;
    margin-right: 30px;
    width: 130px;
    height: 32px;
    line-height: 32px;
    background: #f3f3f3;
    color: #999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;
    padding:0;
    &.active{
      background:$bgColor;
      color:#fff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/examination/Index.vue